import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import * as brokerHooks from "@rentiohq/shared-frontend/dist/redux/broker/broker.hooks";
import { EBrokerFeature } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { IPaymentOrder } from "@rentiohq/shared-frontend/dist/types/payment.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import { RentioInternalRenderer } from "@rentiohq/web-shared/dist/components";
import { OpenPaymentRequests } from "components/OpenPaymentRequests";
import { round } from "lodash";
import React from "react";
import { PaymentHistory } from "scenes/PaymentsOverview/PaymentHistory";
import { CollectionFollowUp as CollectionFollowUpV2 } from "../components/CollectionFollowUpV2";
import { PayInsFollowUp } from "../components/PayInsFollowUp";
import { PropertyPaymentOrders } from "./components/PropertyPaymentOrders";

interface IProps {
  property: IProperty;
}

export const getAmounts = (paymentOrder: IPaymentOrder) => {
  const { isRepetitionDelayed, proRataAmount, amount, vat = 0 } = paymentOrder;
  const vatPercentage = vat / 100;

  let firstAmount: number | undefined = undefined;
  if (proRataAmount > 0) {
    if (isRepetitionDelayed) {
      firstAmount = +amount + +proRataAmount;
    } else {
      firstAmount = +proRataAmount;
    }
  }

  const amountWithVat = round(amount * (1 + vatPercentage), 2);

  const firstAmountWithVat = firstAmount
    ? round(firstAmount * (1 + vatPercentage), 2)
    : undefined;

  return {
    vat: paymentOrder.vat,
    amount,
    amountVat: amountWithVat - amount,
    amountWithVat,
    firstAmount,
    firstAmountVat:
      firstAmount && firstAmountWithVat
        ? firstAmountWithVat - firstAmount
        : undefined,
    firstAmountWithVat,
  };
};

export const PaymentsOverview = (props: IProps) => {
  const { property } = props;

  const [refreshKey, setRefreshKey] = React.useState(0);

  // Redux
  const { isBroker } = authHooks.useSelf();
  const hasIbanisationForBroker =
    brokerHooks.useBrokerFeature(EBrokerFeature.Ibanisation) || !isBroker;

  const handlePaymentRequestDeleted = () => {
    setRefreshKey(prev => prev + 1);
  };

  // Render
  return (
    <>
      <RentioInternalRenderer>V2</RentioInternalRenderer>

      <PropertyPaymentOrders propertyId={property.id} key={refreshKey} />

      <CollectionFollowUpV2 propertyId={property.id} />

      {hasIbanisationForBroker && <PayInsFollowUp propertyId={property.id} />}

      <OpenPaymentRequests
        propertyId={property.id}
        onDeleted={handlePaymentRequestDeleted}
      />

      <PaymentHistory propertyId={property.id} />
    </>
  );
};
